class TaskModel{
    constructor(tracktername,percentage,completiontime,status,state,zindex,pindex,cindex,batteryColor,trajectory,schedule,implementName="",taskname = ""){
     this.tracktername = tracktername;
     this.implementName = implementName;
     this.percentage = percentage;
     this.completiontime = completiontime;
     this.status = status;
     this.state = state;
     this.taskname = taskname;
     this.zindex = zindex
     this.pindex = pindex
     this.cindex = cindex
     this.batteryColor = batteryColor
     this.trajectory = trajectory
     this.schedule = schedule
     
    }
}

export default TaskModel;